"use strict";

import Config from './Config';

/**
 * Azure media player ES6 shim
 * https://ampdemo.azureedge.net/
 */
export default class AzureMediaPlayer {
    static initialize() {
        if (!window.amp) {
            let scriptElement = document.createElement("script");
            scriptElement.src = "//amp.azure.net/libs/amp/" + Config.MEDIA_PLAYER_VERSION + "/azuremediaplayer.min.js";
            document.head.appendChild(scriptElement);
        }
    }
}
